<!-- 背景印花 -->
<template>
  <div id="watermark"></div>
</template>

<script>
export default {
  name: "Watermark",
  components: {},
  props: {
    watermarkStr: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      //调整密度
      width:190,
      height:190,
      //调整深浅
      opacity: 0.08
    };
  },
  mounted() {
    this.createWatermark(this.watermarkStr);
  },
  created() {},
  methods: {
    createWatermark(str) {
      const width = this.width;
      const height = this.height;
      const canvas = Object.assign(document.createElement("canvas"), {
        width,
        height,
      });

      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.rotate((Math.PI / 120) * -20);
        ctx.font = "16px Microsoft Yahei";
        ctx.fillStyle = `rgba(0, 0, 0, ${this.opacity})`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(str, width / 10, height / 1.5);
      }
      const base64 = canvas.toDataURL("image/png");

      // 设置元素
      var element = document.getElementById("watermark");
      element.style = `background:url(${base64}) repeat center center fixed`;
      return base64;
    },
  },
};
</script>

<style scoped lang="less">
#watermark {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999999;
  pointer-events: none;
}
</style>
